import classNames from 'classnames';
import { TFunction } from 'i18next';
import React from 'react';
import { ProIconButton } from '../../../../atoms/Button/ProIconButton';
import { ProIcon } from '../../../../atoms/Icons/Icon';
import { ProIconData, ProIconDataButtons } from '../../../../atoms/Icons/IconData';
import { TableColData } from '../../../../atoms/Table/Table';
import { translateStatus } from '../../../../components/DetailWindow/breadCrump.helpers';
import { getIconForTypeInNameCell } from '../../../../modules/Windows/WBSElement/WBSElement.helpers';
import { ProIntent, ProSize } from '../../../../utils/enums';
import { Components } from '../../../../utils/types';
import { getReqStatusIcon } from '../../Requirements/components/RequirementTableNameCell';

export const getReviewSprintTableData = ({
    selectElement,
    t,
    selectSprint,
    selectedSprint,
    wbsIsDisplayed,
    sync,
    portfolio,
    setSelectedTableRow,
}: {
    selectElement: (id?: string) => void;
    setSelectedTableRow: (i: number) => void;
    t: TFunction;
    selectSprint: () => void;
    selectedSprint?: Components.Schemas.WBSElementDeltaDTO;
    wbsIsDisplayed: boolean;
    portfolio?: Components.Schemas.PortfolioDTO;
    sync: () => void;
}): TableColData[] => [
    {
        name: 'Sprint',
        cellRender: (i) => {
            if (i === 0)
                return (
                    <>
                        <div className="ProTable__levelBars ">
                            <div className={classNames('ProTable__levelBar', `ProTable__levelBar-1`)}>1</div>
                        </div>

                        <div className={classNames('ProTable__level', 'ProTable__level--open')}>
                            <ProIcon icon={ProIconData.chevron_outline_down} customSize="14" />
                        </div>

                        <span className="ProTable__name" onClick={() => selectSprint()}>
                            {selectedSprint?.wbsElementType && getIconForTypeInNameCell(selectedSprint.wbsElementType)}
                            {selectedSprint?.name}
                        </span>
                    </>
                );
            else
                return (
                    <>
                        <div className="ProTable__levelBars ">
                            <div className="ProTable__levelBar ProTable__levelBar-2">1</div>
                        </div>
                        <span
                            className="ProTable__name"
                            onClick={() =>
                                selectElement(
                                    selectedSprint?.requirements ? selectedSprint?.requirements[i - 1].id : undefined
                                )
                            }
                        >
                            <ProIcon size={ProSize.Small} icon={ProIconData.base_data} />
                            {selectedSprint?.requirements && selectedSprint.requirements[i - 1].name}
                        </span>
                    </>
                );
        },
        className: 'TableRowName ProTable__levels',
        colSpace: 'extend',
    },
    {
        name: 'Status',
        cellRender: (i) => (
            <>
                {selectedSprint &&
                    selectedSprint.requirements &&
                    selectedSprint.requirements[i - 1] &&
                    getReqStatusIcon(
                        selectedSprint.requirements[i - 1].requirementType,
                        selectedSprint.requirements[i - 1].requirementState?.name
                    )}
                {selectedSprint &&
                    selectedSprint.requirements &&
                    selectedSprint.requirements[i - 1] &&
                    translateStatus(t, selectedSprint.requirements[i - 1].requirementState?.name)}
            </>
        ),
        colSpace: wbsIsDisplayed ? 3 : 4,
        className: 'ProTable__statusIcon',
    },
    {
        name: t('table.cols.responsible'),
        cellRender: (i) =>
            selectedSprint?.responsiblePerson
                ? `${selectedSprint.responsiblePerson?.firstName ?? ''} ${
                      selectedSprint.responsiblePerson?.lastName ?? 'no data'
                  }`
                : '',
        hidden: () => !wbsIsDisplayed,
        colSpace: 4,
    },
    {
        name: t('table.cols.constraint'),
        cellRender: (i) => selectedSprint?.constraintQualityType,
        hidden: () => !wbsIsDisplayed,
        colSpace: 4,
    },
    {
        name: 'SP',
        cellRender: (i) => selectedSprint?.scopePoints,
        colSpace: 1,
    },

    {
        name: t('table.cols.action'),
        cellRender: (i) => (
            <div className="ProTable--actionCell">
                <ProIconButton
                    icon={ProIconDataButtons.arrow_right_xs}
                    tooltip={t('buttons.open')}
                    mainIntent={ProIntent.Transparent}
                    hoverIntent={ProIntent.Secondary}
                    size={ProSize.XSmall}
                    onClick={() => {
                        if (i === 0) selectSprint();
                        else {
                            selectElement(
                                selectedSprint?.requirements ? selectedSprint.requirements[i - 1].id : undefined
                            );
                            setSelectedTableRow(i);
                        }
                    }}
                    lineIntent={ProIntent.Secondary}
                    placement="bottom"
                />
            </div>
        ),
        className: `ProTable__buttons`,
        colSpace: 2,
    },
];
